import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Stack } from '@famly/mf_layout_stack';
import { SplitModalContext } from './split-modal';
const FOOTER_STYLES = {
    fullModal: {
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        alignItems: 'center',
        borderTop: 'n100',
        flexDirection: 'row',
    },
    contextual: {
        backgroundColor: 'n50',
        padding: '24px',
        gap: '16px',
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        borderLeft: 'n100',
    },
};
/**
 * Footer container that adapts based on modal variant.
 * - FullModal: spans both columns with grid layout for descriptions + buttons
 * - Contextual: sticky footer in right column area
 *
 * @param children - Footer content (buttons, descriptions)
 * @example
 * ```tsx
 * <SplitModalFooter>
 *   <SplitModalFooterButtons>
 *     <ModalSecondaryButton text="Cancel" />
 *     <ModalPrimaryButton text="Save" />
 *   </SplitModalFooterButtons>
 * </SplitModalFooter>
 * ```
 */
export const SplitModalFooter = ({ children, ...props }) => {
    const context = React.use(SplitModalContext);
    if (!(context === null || context === void 0 ? void 0 : context.variant)) {
        return null;
    }
    const footerStyle = FOOTER_STYLES[context.variant] || {};
    return (_jsx(Stack, { component: "footer", ...props, style: { gridArea: 'footer' }, padding: "24px", flexDirection: "column", ...footerStyle, children: children }));
};
